import { Badge } from "react-bootstrap";

const RoleBadge = ({ role }) => {
  const roleClasses = {
    Owner: "bg-warning bg-opacity-10 text-warning",
    Admin: "bg-primary bg-opacity-10 text-primary",
    Certifier: "bg-danger bg-opacity-10 text-danger",
    Member: "bg-info bg-opacity-10 text-dark",
  };
  return (
    <Badge
      className={`p-1 px-2 ${roleClasses[role] || "bg-secondary bg-opacity-10 text-dark"}`}
    >
      {role}
    </Badge>
  );
};

export default RoleBadge;
